// Code generated by pkg/router_helper/make_api.go, DO NOT EDIT.

import { fetchApi } from '../fetchApi'

import * as Types from './type'

export const messageApi = {
  postUserMessageClosePop: {
    method: 'post',
    path: '/api-bff/user/message/closePop',
    fnMeta: {
      parameters: [
        {
          kind: 'body',
        },
      ],
      returnType: {
        kind: '',
      },
    },
    flag: null,
  },
  postUserMessageListPopMessage: {
    method: 'post',
    path: '/api-bff/user/message/listPopMessage',
    fnMeta: {
      parameters: [
        {
          kind: 'body',
        },
      ],
      returnType: {
        kind: '',
      },
    },
    flag: null,
  },
}

export function postUserMessageListPopMessage(body: Types.UserMsgListPopRequest, ...args: any): Promise<Types.UserMsgListPopResponse> {
  return fetchApi(messageApi.postUserMessageListPopMessage as any, body, ...args) as Promise<Types.UserMsgListPopResponse>
}

export function postUserMessageClosePop(body: Types.UserMsgClosePopRequest, ...args: any): Promise<Types.UserMsgListPopResponse> {
  return fetchApi(messageApi.postUserMessageClosePop as any, body, ...args) as Promise<Types.UserMsgListPopResponse>
}
